<div class="card ">
  <div class="card-header card-header-rose card-header-icon">
    <div class="card-icon">
      <i class="material-icons">mail_outline</i>
    </div>
    <h4 class="card-title">Envoyer un message au support technique</h4>
  </div>
  <div class="card-body ">
    <form [formGroup]="controlForm">
      <mat-form-field [color]="param.color" class="example-full-width" [class.has-danger]="email.invalid" [class.has-succes]="email.valid">
        <input matInput placeholder="Votre adresse email" type="email" formControlName="email" required>
        <span class="form-control-feedback" *ngIf="email.valid">
          <i class="material-icons">done</i>
        </span>
        <span class="form-control-feedback" *ngIf="email.invalid">
          <i class="material-icons">clear</i>
        </span>
      </mat-form-field>
      <mat-form-field [color]="param.color" class="example-full-width">
        <mat-label>Votre message</mat-label>
        <textarea matInput
                  cdkTextareaAutosize
                  cdkAutosizeMinRows="10"
                  cdkAutosizeMaxRows="40"
                  style="color: #333333;" [(ngModel)]="corps" [ngModelOptions]="{standalone: true}"></textarea>
      </mat-form-field>
    </form>
  </div>
  <div class="card-footer ">
    <button _ngcontent-cfq-c3="" (click)="onNoClick()" class="btn btn-fill btn-rose">Annuler</button>
    <button mat-raised-button (click)="onClick()" [disabled]="controlForm.invalid" type="submit" class="btn btn-fill btn-rose">Valider</button>
  </div>
</div>
